export default {"src":"/_next/static/media/square-foot.657f1495.svg","height":23,"width":22,"blurWidth":0,"blurHeight":0};